import { render, staticRenderFns } from "./activityCollectionConfig.vue?vue&type=template&id=33376c91&scoped=true&"
import script from "./activityCollectionConfig.vue?vue&type=script&lang=js&"
export * from "./activityCollectionConfig.vue?vue&type=script&lang=js&"
import style0 from "./activityCollectionConfig.vue?vue&type=style&index=0&id=33376c91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33376c91",
  null
  
)

export default component.exports